import { createFileRoute } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { useConvex } from 'convex/react'
import { api } from 'convex/_generated/api'

export const Route = createFileRoute('/dashboard')({
  component: Dashboard,
})

function Dashboard() {
  const convex = useConvex()

  // Demo: Query recent Tempolor generations from Convex
  const { data, isLoading, error } = useQuery({
    queryKey: ['recentGenerations'],
    queryFn: async () => {
      return await convex.query(api.tempolor.listByUser, { limit: 5 })
    },
  })

  return (
    <div className="px-4 py-6 sm:px-0">
      <div className="border-4 border-dashed border-gray-200 rounded-lg p-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Dashboard</h1>

        <div className="bg-white shadow rounded-lg p-6">
          <h2 className="text-2xl font-semibold mb-4">TanStack Query + Convex Demo</h2>
          <p className="text-gray-600 mb-4">
            Recent Tempolor generations from Convex database
          </p>
          {isLoading && <p className="text-gray-600">Loading...</p>}
          {error && <p className="text-red-600">Error: {error.message}</p>}
          {data && (
            <div className="bg-gray-50 rounded p-4">
              {data.length === 0 ? (
                <p className="text-gray-500 text-sm">
                  No generations yet. Visit{' '}
                  <a href="/example-song" className="text-blue-600 hover:underline">
                    /example-song
                  </a>{' '}
                  to create one!
                </p>
              ) : (
                <pre className="text-sm overflow-auto">
                  {JSON.stringify(data, null, 2)}
                </pre>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
